@if (showSearch) {
    <pf-input
        class="custom-field-list-search"
        inputType="search"
        [control]="searchControl"
        [placeholder]="searchPlaceholder"></pf-input>
}
<div class="custom-field-list">
    <div class="custom-field-list-header">
        @if (listLabel) {
            <pf-text type="primary" bold
                >{{ listLabel }}
                @if (tooltip) {
                    <pf-icon iconType="info" [nz-tooltip]="tooltip"></pf-icon>
                }
            </pf-text>
        }
        <pf-button buttonType="action" (click)="clearAllItems()"
            >Clear All</pf-button
        >
    </div>
    @for (
        item of listControls$ | async;
        track item;
        let inputIndex = $index;
        let firstItem = $first;
        let lastItem = $last
    ) {
        <div class="custom-field-list-item">
            @if (inputType === "text") {
                <pf-input
                    #inputItem
                    (keyup.enter)="focusNextOrAddNewItem(inputIndex)"
                    pfStyle="compact"
                    [control]="item.formControl"
                    (pfInput)="onInput()"
                    [datalist]="multiTextAutoCompleteOptions | safeArray"
                    inputType="text"></pf-input>
            }
            @if (inputType === "select") {
                <pf-select
                    #inputItem
                    (selected)="itemSelected(inputIndex)"
                    pfStyle="compact"
                    [control]="item.formControl"
                    [grouped]="grouped"
                    [data]="options | safeArray"></pf-select>
            }
            @if (inputType === "multi-text") {
                <pf-input
                    #inputItem
                    [label]="listHeaders && firstItem ? listHeaders[0] : ''"
                    pfStyle="stacked"
                    [control]="item.formControl"
                    (pfInput)="onInput()"
                    inputType="text"></pf-input>
                <pf-input
                    #inputItem
                    (keyup.enter)="focusNextOrAddNewItem(inputIndex)"
                    [label]="listHeaders && firstItem ? listHeaders[1] : ''"
                    pfStyle="stacked"
                    [control]="item.formControl2"
                    (pfInput)="onInput()"
                    [datalist]="multiTextAutoCompleteOptions | safeArray"
                    inputType="text"></pf-input>
            }
            <span class="custom-field-list-action">
                <pf-icon
                    [ngClass]="{
                        'custom-field-list-action-offset':
                            firstItem && listHeaders?.length
                    }"
                    iconType="close"
                    (click)="removeItem(item.listId)"></pf-icon>
            </span>
            <span class="custom-field-list-action">
                @if (checkItemLimit(lastItem)) {
                    <pf-icon
                        [ngClass]="{
                            'custom-field-list-action-offset':
                                firstItem && listHeaders?.length
                        }"
                        iconType="plus"
                        (click)="addNewItem()"></pf-icon>
                }
            </span>
        </div>
    }
</div>
